import { render, staticRenderFns } from "./PriceValuationInput.vue?vue&type=template&id=0dd81fe4&scoped=true&"
import script from "./PriceValuationInput.vue?vue&type=script&lang=ts&"
export * from "./PriceValuationInput.vue?vue&type=script&lang=ts&"
import style0 from "./PriceValuationInput.vue?vue&type=style&index=0&id=0dd81fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd81fe4",
  null
  
)

export default component.exports